// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3016":"0b807f8d","3912":"9f4a9d7e","4522":"0b807f8d","5680":"0b807f8d","6572":"9f4a9d7e","7399":"95572145","9053":"0b807f8d","9647":"9f4a9d7e","9895":"9f4a9d7e"}[chunkId] + ".chunk.css";
};